import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as utilities from '#utilities/js/styles.js'
import { elements, modifiers } from '../styles.js'
import { manageButton } from './button.js'

const containers = new WeakMap()
const params = new WeakMap()

const managePanel = (({ panel, panelUid }) => {
  requestAnimationFrame(() => {
    const { dataset } = panel
    const { panelType } = dataset

    if (panel.classList.contains(elements.collapse_panel_is_open)
      && getComputedStyle(panel).getPropertyValue('--ea_collapse_panel_is_open') === 'true') {
      panel.classList.add(modifiers.collapse_panel.open)

      if (panelType === 'default') {
        panel.classList.remove(utilities.modifiers.visibility.hidden)
      }
    } else {
      panel.classList.remove(modifiers.collapse_panel.open)

      if (panelType === 'default') {
        panel.classList.add(utilities.modifiers.visibility.hidden)
      }
    }
  })

  manageButton(panel, panelUid)
})

export default panel => {
  const { ownerDocument } = panel
  const { dataset } = panel
  const { panelUid } = dataset

  if (panelUid) {
    if (Object.hasOwn(globalThis, 'ontransitionend')) {
      panel.classList.add(modifiers.has.transition_end)
    } else {
      panel.classList.add(utilities.modifiers.display.none)
    }

    queueMicrotask(async () => {
      const parameters = object(null, { panel, panelUid })

      if (!containers.has(ownerDocument)) {
        containers.set(ownerDocument, new Set())
      }

      const nestedContainers = containers.get(ownerDocument)

      nestedContainers.add(panel)
      params.set(panel, parameters)
      managePanel(parameters)
      await removed(panel)
      params.delete(panel)
      nestedContainers.delete(panel)
    })
  }
}
